"use client";

import React from "react";
import { notFound, useParams } from "next/navigation";
import { Collections } from "../data/collections";
import Image from "next/image";
import Link from "next/link";

export default function CollectionDetailPage() {
  const formatDateToFrench = (dateStr: string) => {
    const [month, year] = dateStr.split("/");
    const months = {
      "01": "JANVIER",
      "02": "FÉVRIER",
      "03": "MARS",
      "04": "AVRIL",
      "05": "MAI",
      "06": "JUIN",
      "07": "JUILLET",
      "08": "AOUT",
      "09": "SEPTEMBRE",
      "10": "OCTOBRE",
      "11": "NOVEMBRE",
      "12": "DÉCEMBRE",
    };

    return `${months[month as keyof typeof months]} 20${year}`;
  };

  const { slug } = useParams();
  const collection = Collections.find((collection) => collection.id === slug);

  if (!collection) {
    notFound();
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="relative h-[60vh] w-full">
        <Image
          src={collection.bannerImage}
          alt={collection.title}
          className="h-full w-full object-cover"
          width={1920}
          height={1080}
        />
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="px-4 text-center text-white">
            <span className="border-b border-gold pb-2 text-sm uppercase tracking-widest">
              {formatDateToFrench(collection.date)}
            </span>
            <h1 className="mt-6 font-serif text-5xl font-light">
              {collection.title}
            </h1>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-16 px-4 pb-20 pt-8 ph:px-24 md:px-48 lg:px-72 xl:px-96">
        <div className="flex w-full flex-row justify-between">
          <div>
            <Link
              href="/collections"
              className="inline-flex items-center text-primary transition-colors hover:text-gold"
            >
              <svg
                className="mr-2 h-4 w-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              Retour aux collections
            </Link>
          </div>
        </div>

        <div className="flex flex-col gap-4 xl:gap-6">
          {collection.descriptionParagraphs?.map((paragraph, index) => (
            <p key={index} className="text-base leading-relaxed">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {collection.images.map((image, index) => (
            <div key={index} className="aspect-[3/4] w-full overflow-hidden">
              <Image
                src={image}
                alt={`${collection.title} - Image ${index + 1}`}
                className="h-full w-full object-cover"
                width={800}
                height={1200}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
